module.exports = __webpack_public_path__ + "static/media/smvdu.194e1c0b.png";